module.exports = __webpack_public_path__ + "img/about/80243-041.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-041.png
// module id = 39
// module chunks = 0